<template>
  <div class="withd_body">

    <div class="beij">
      <div class="fangshi">
        <span style="font-size: 14px;color: #ccc">到账方式</span>
        <span style="font-size: 14px;font-weight: 500;position: absolute;right: 10px;">微信</span>
      </div>

      <div class="jine">
        <div class="chongzhijine">提现金额</div>
        <div class="shuru">
          <van-cell-group>
            <div class="qian">¥</div>
            <div><van-field v-model="value" placeholder="" /></div>
          </van-cell-group>
        </div>
      </div>

      <div class="yuetixian">
        <span>零钱余额¥100.00</span>
<!--        <span style="color: #333;padding: 10px;font-size: 14px;">全部提现</span>-->
      </div>

    </div>

    <div><van-button type="primary" block>确定</van-button></div>

  </div>
</template>

<script>
    export default {
        name: "withdrawal",
        data(){
            return{
                value:'',
            }
        },
        created() {

        },
        methods:{

        }
    }
</script>

<style scoped lang="stylus">
  .withd_body{
    position: absolute;
    width 100%;
    background-color #f1f1f1;
    height 100%;
    padding-top 10px;
    >>>.van-button--block{
      margin 10px auto;
      width 90%;
      border-radius 10px;
    }
    .beij{
      background-color #ffffff;
      width 95%;
      height 180px;
      margin auto;
      border-radius 10px;
      .yuetixian{
        color #ccc;
        width 95%;
        margin 10px auto
      }
    }
    .fangshi{
      position relative;
      height 40px;
      line-height 40px;
      margin-left  10px;
      margin-right  10px;
      border-bottom 1px solid #f4f4f4
    }
    .jine{

      .chongzhijine{
        font-size 16px;
        color #ccc;
        margin-left 10px;
        margin-top 10px;
      }
      .shuru{
        border-bottom 1px solid #f2f2f2;
        width 95%;
        margin auto;
        height 60px;
        .qian{
          font-size 40px;
          width 8%;
          margin-left 10px;
        }
      }
      >>>.van-cell{
        width 80%;
        padding 0px;
        margin-left 10px;
        font-size 28px;
      }
      >>>.van-cell-group{
        display flex;
        width 100%;
        flex-direction: row;
        /*justify-content: center;*/
        align-items: center;
      }

      >>>.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
        border 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wode/topup.vue